import { render, staticRenderFns } from "./BdThread.vue?vue&type=template&id=315660f6&scoped=true&"
import script from "./BdThread.vue?vue&type=script&lang=js&"
export * from "./BdThread.vue?vue&type=script&lang=js&"
import style0 from "./BdThread.vue?vue&type=style&index=0&id=315660f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315660f6",
  null
  
)

export default component.exports